const types = [
  {
    label: "Jurídica",
    value: "J",
  },
  {
    label: "Internacional",
    value: "I",
  },
];

export default types;
